import React from 'react';
import PropTypes from 'prop-types';

import classes from './FourOptionsSelector.css';

const fourOptionsSelector = props => {
  const {
    selectedOption,
    option1,
    option2,
    option3,
    option4,
    selectedOption1,
    selectedOption2,
    selectedOption3,
    selectedOption4
  } = props;

  return (
    <div className={classes.FourOptionsSelector}>
      <div className={classes.SelectorWrapper}>
        <div
          className={selectedOption === option1 ? classes.Active : null}
          onClick={selectedOption1}
        >
          <h4>{option1}</h4>
        </div>
        <div
          className={selectedOption === option2 ? classes.Active : null}
          onClick={selectedOption2}
        >
          <h4>{option2}</h4>
        </div>
        <div
          className={selectedOption === option3 ? classes.Active : null}
          onClick={selectedOption3}
        >
          <h4>{option3}</h4>
        </div>
        <div
          className={selectedOption === option4 ? classes.Active : null}
          onClick={selectedOption4}
        >
          <h4>{option4}</h4>
        </div>
      </div>
    </div>
  );
};

fourOptionsSelector.propTypes = {
  selectedOption: PropTypes.string.isRequired,
  option1: PropTypes.string.isRequired,
  option2: PropTypes.string.isRequired,
  option3: PropTypes.string.isRequired,
  option4: PropTypes.string.isRequired,
  selectedOption1: PropTypes.func,
  selectedOption2: PropTypes.func,
  selectedOption3: PropTypes.func,
  selectedOption4: PropTypes.func
};

export default fourOptionsSelector;
